/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";

const AdsImage = ({fileContent,fileName, fileType}) => {
  const [imageData, setImageData] = useState(null);

  useEffect(() => {
    const receivedData = {
      fileContent,
      fileName,
      fileType
    };
    const imageData = `data:${receivedData.fileType};base64,${receivedData.fileContent}`;
    setImageData(imageData);
  },[]);

  return ( 
    <div>
    <img src={imageData} alt={fileName} height={'100px'} width={'100px'}/>
  </div>
);
};

export default AdsImage;
